import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import Pagination from '@/components/Pagination.vue'
import { useRouter,useRoute } from 'vue-router'
import { joinParams } from '@/utils/index'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { BrandM } from '@/models/brand'
import SelectBrand from '@/components/SelectBrand.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaleList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()

    const store = useStore()
    const filters = reactive({
            start_date:        route.query.start_date || '', 
            end_date:        route.query.end_date || '',   
            export_type:      0,
            remittance_status:route.query.remittance_status == '0' ?'':route.query.remittance_status ||'',   //结算状态
            brand_id:'',
            page:        1,      // 当前页码
            limit:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
    })
    const tableData = ref([])
    const total = ref(0)
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/admin/merchant/get_ordergmv_list', filters).then(res => {
            const { code, data, msg,count } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data
            total.value = count
        })
    }
    //获取品牌列表
    const brandList = ref<BrandM[]>([])
    const onBrandChange = (val) => {
        filters.brand_id = val
    }
    const out = (type) => {
        window.open(`${Keys.baseUrl}/admin/merchant/get_ordergmv_list?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.limit = val
        getList()
    }
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期"
      }, null, 8, ["modelValue"]),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.remittance_status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.remittance_status) = $event)),
        placeholder: "结算状态",
        style: {"width":"170px"},
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "已结算",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "未结算",
            value: "2"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(SelectBrand, {
        class: "filter-item",
        style: {"margin-right":"10px"},
        ifBody: 2,
        onBrandChange: onBrandChange
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (out(1)))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "day",
          label: "月份"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "销售额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total",
          label: "订单量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "single_price",
          label: "客单价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "jiesaun_amount",
          label: "应结算金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remittance_txt",
          label: "结算状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remittanee_amount",
          label: "已结算金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remittance_time",
          label: "结算时间"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})